<template>
  <div class="table-area">
    <div class="table-a">
      <div class="table-name">
        <h3 class="ico_table_name">{{title}}</h3>
      </div>
      <table id="basic" class="table infotable">
        <tbody>
          <tr>
            <th>입고일자</th>
            <th>입고구분</th>
            <th>입고번호</th>
            <th>제조사</th>
            <th>제품군</th>
            <th>품번</th>
            <th>품명</th>
            <th>수량</th>
          </tr>
          <tr>
            <!--<td><input class="input" type="text" v-model="this.$moment(form.inDt).format('YYYY-MM-DD')" style="text-align:center;" disabled ></td>-->
            <td><input class="input" type="text" v-model="form.inDt" style="text-align:center;" disabled ></td>
            <td><input class="input" type="text" v-model="form.inTypeNm" style="text-align:center;" disabled ></td>
            <td><input class="input" type="text" v-model="form.inItemId" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.makerNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.itemGroupNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.itemCd" disabled></td>
            <td><input class="input" type="text" v-model="form.itemNm" disabled></td>
            <td><input class="input" type="text" v-model="form.goodQty" style="text-align:right;"></td>
            <input class="input" type="hidden" v-model="form.groupUid">
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import mixin from '@/mixin/lucoms';

export default {
  name: "mateEnteringInfo",
  mixins: [mixin],
  props: ['mateEnteringDetail'],
  data() {
    return {
      title : "입고 수정",
      form: {
        companyCd : '',
        productType : 'Item',
        inItemId: '',
        inDt: '',
        inType : '',
        asAgentId : '',
        itemId : '',
        goodQty: '',
        recycleQty : 0,
        badQty : 0,
        outAgentId : 0,
        inTypeNm: '',
        makerNm: '',
        itemGroupNm: '',
        itemCd: '',
        itemNm: '',
        description : '',
        //outItemRequestId : '',
      },
    };
  },
  methods: {
    setMateEnteringDetailInfo() {
      Object.assign(this.form, this.mateEnteringDetail);
    },
    validation() {
      const mateEnteringInfo = JSON.parse(JSON.stringify(this.form));
      const stripFields = ['goodQty'];
      _.forEach(stripFields, (name) => mateEnteringInfo[name] = this.toPure(mateEnteringInfo[name]));

      if ( mateEnteringInfo.goodQty <= 0 ) {
        this.$swal({type: 'warning', text: '수량을 입력해 주세요.'});
        return false;
      }
      return true;
    },
    dataClear(){
      this.form.inDt = ''
      this.form.inTypeNm = ''
      this.form.inItemId = ''
      this.form.makerNm = ''
      this.form.itemGroupNm = ''
      this.form.itemGroupNm = ''
      this.form.itemCd = ''
      this.form.itemNm = ''
      this.form.goodQty = ''
      this.form.groupUid = ''
    }
  },
  watch: {
    mateEnteringDetail() {
      this.setMateEnteringDetailInfo();
    },
    'form.inDt':{
      immediate: true,
      deep: true,
      handler(value) {
        if( value !== ''){
          this.form.inDt = this.$moment(value).format('YYYY-MM-DD');
        }
      }
    }
  }
}
</script>

<style scoped>
</style>